import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Lock, ShieldCheck } from "lucide-react";
import { api, fmtErr } from "../lib/api";
import { PinBoxes } from "../components/PinBoxes";

export default function ReimpostaPin() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [step, setStep] = useState(1);
  const [firstPin, setFirstPin] = useState("");
  const [resetKey, setResetKey] = useState(0);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const complete = async (pin) => {
    if (step === 1) {
      setFirstPin(pin); setStep(2); setError(""); setResetKey((k) => k + 1);
      return;
    }
    if (pin !== firstPin) {
      setStep(1); setFirstPin(""); setError("I due PIN non coincidono. Riprova."); setResetKey((k) => k + 1);
      return;
    }
    setBusy(true);
    try {
      await api.post("/memoria/pin/reset", { token, pin });
      setDone(true);
    } catch (e) {
      setError(fmtErr(e)); setStep(1); setFirstPin(""); setResetKey((k) => k + 1);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16 text-center" data-testid="reimposta-pin-page">
      <div className="w-16 h-16 mx-auto rounded-full border border-amber-500/40 bg-[#1a0b2b] flex items-center justify-center shadow-[0_0_35px_rgba(251,191,36,0.12)]">
        <Lock className="w-7 h-7 text-amber-300" />
      </div>
      <h1 className="font-display text-3xl text-amber-100 mt-6">Nuovo PIN</h1>
      {!token && !done && (
        <p className="text-rose-300 text-sm mt-5" data-testid="pin-reset-invalid">Questo link non è valido. Richiedi un nuovo recupero dalla tua memoria.</p>
      )}
      {token && !done && (
        <div data-testid="pin-reset-flow">
          <p className="text-purple-100/80 text-sm leading-relaxed mt-5 max-w-sm mx-auto">
            Crea il tuo nuovo PIN di 4 cifre. Il vecchio PIN sarà annullato e le tue conversazioni resteranno al loro posto.
          </p>
          <p className="text-amber-200/90 text-xs tracking-[0.2em] uppercase mt-8 mb-4" data-testid="pin-reset-step-label">
            {step === 1 ? "Scegli il nuovo PIN" : "Ripeti il PIN per confermare"}
          </p>
          <PinBoxes testid="pin-reset" onComplete={complete} resetKey={resetKey} />
          {error && <p className="text-rose-300 text-xs mt-4" data-testid="pin-reset-error">{error}</p>}
          {busy && <p className="text-purple-300/50 text-xs mt-3">Salvataggio…</p>}
        </div>
      )}
      {done && (
        <div data-testid="pin-reset-success">
          <ShieldCheck className="w-10 h-10 text-emerald-300 mx-auto mt-6" />
          <p className="text-purple-100/80 text-sm leading-relaxed mt-5 max-w-sm mx-auto">
            Nuovo PIN creato. Le tue conversazioni sono rimaste al loro posto.
          </p>
          <Link to="/memoria" data-testid="pin-reset-goto-memoria" className="gold-btn inline-block mt-6 px-8 py-3 text-sm">
            Apri la mia memoria
          </Link>
        </div>
      )}
    </div>
  );
}
